import { render, staticRenderFns } from "./B2.vue?vue&type=template&id=48b776b3&scoped=true&"
import script from "./B2.vue?vue&type=script&lang=js&"
export * from "./B2.vue?vue&type=script&lang=js&"
import style0 from "./B2.vue?vue&type=style&index=0&id=48b776b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b776b3",
  null
  
)

export default component.exports